module.exports = function() {
  return new Worker(__webpack_public_path__ + "ada85886aee266227cfd.worker.js");
};